<div *ngIf="resources()?.length">
  <span *ngIf="displayHeader()" class="sources-span">Sources {{ resources().length }}</span>
  <div class="resource-container" #wrapper [class.avoid-wrap]="hasTwoResourcesOverflow()" [class.has-plus]="additionalResources()?.length">
    <div *ngFor="let resource of sliceResources(); let i = index" #shortResultResource class="short-result-resource">
      <short-result-resource
        [model]="resource"
        [referenceIndex]="showResourcesNumbers() ? i + 1 : 0"
        [isSingleResource]="resources().length === 1"
        (invoke)="onInvoke($event, 'result', i)"
        (menuActive)="isMenuActive($event)"
        [showAllResourcesClicked]="showAllResources()"
        [resourceActiveIndex]="resourceActiveIndex()"
        [searchId]="searchId()"
        [hasTwoResourcesOverflow]="hasTwoResourcesOverflow()"
      ></short-result-resource>
    </div>
    <div *ngIf="additionalResources()?.length">
      <short-result-resource
        (menuActive)="isMenuActive($event)"
        [additionalResources]="additionalResources()"
        (onAdditionalResourcesClick)="onAdditionalResourcesClick($event)"
        [isSingleResource]="false"
        [seeAll]="seeAll()"
      ></short-result-resource>
    </div>
  </div>
</div>
